import React from 'react';

import { Section, Stack, Button } from '@gogame/components';
import { withForm, FormField, SubmitButton } from '@gogame/form';

import {
  Container,
  Content,
  Footer,
} from 'scenes/AssistedInstalls/components/ExportForm/components';
import { APP_ID, PERIOD } from 'scenes/AssistedInstalls/constants';
import { downloadSchema } from 'scenes/AssistedInstalls/schemas';
import { loadApplications } from 'scenes/AssistedInstalls/source/fields';

const ExportForm = withForm({
  enableReinitialize: true,
  validationSchema: downloadSchema,
})(({ resetForm }) => {
  const handleClear = () => {
    resetForm({});
  };

  return (
    <Container>
      <Content>
        <Section title={'Export Settings'}>
          <Stack spacing={3}>
            <FormField.DateRangePicker
              name={PERIOD}
              padding={0}
              required={true}
              label={'Period'}
            />
            <FormField.MultiSelect
              name={APP_ID}
              label={'Application'}
              source={loadApplications}
              padding={'0'}
              withAll={false}
              placeholder={'All'}
              required={true}
            />
          </Stack>
        </Section>
      </Content>
      <Footer justifyContent={'space-between'}>
        <Button onClick={handleClear} role={'button'}>
          Clear
        </Button>
        <SubmitButton title={'Export'} />
      </Footer>
    </Container>
  );
});

export default ExportForm;
